import { LoggerProvider as LoggerProviderBase, } from '@opentelemetry/sdk-logs';
import { LogLevel } from '../../types';
import { logMessageWithSeverity } from './utils';
export class LoggerProvider extends LoggerProviderBase {
    constructor(config) {
        super(config);
        this.diagnosticLogger = this.getLogger('diagnostics');
    }
    getLogger(name, version, options) {
        const baseLogger = super.getLogger(name, version, options);
        return Object.assign(baseLogger, {
            debug: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.DEBUG, options),
            error: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.ERROR, options),
            info: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.INFO, options),
            log: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.UNSPECIFIED, options),
            trace: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.TRACE, options),
            warn: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.WARN, options),
            fatal: (message, options) => logMessageWithSeverity(baseLogger, message, LogLevel.FATAL, options),
        });
    }
}
//# sourceMappingURL=logger-provider.js.map